import { userService } from './userService';

// API Configuration - following the same pattern as researchAIService
const PROD_API_BASE = 'https://5z9vmw0tg6.execute-api.eu-north-1.amazonaws.com/production';
const DEV_API_BASE = 'https://9vnb05of2j.execute-api.eu-north-1.amazonaws.com/development';

// Auto-select API by environment
const API_BASE_URL = (() => {
  const fromEnv = process.env.REACT_APP_API_URL;
  if (fromEnv && fromEnv.trim().length > 0) return fromEnv;
  if (typeof window !== 'undefined') {
    const host = window.location.host || '';
    const hostname = window.location.hostname || '';
    const isLocalhost = hostname === 'localhost' || hostname === '127.0.0.1';
    const isDevSite = host.includes('saas-application-dev.s3-website.eu-north-1.amazonaws.com');
    if (isLocalhost || isDevSite) return DEV_API_BASE;
  }
  return PROD_API_BASE;
})();

interface PromptGenerationRequest {
  column_name: string;
  sources: string[];
}

interface PromptGenerationResponse {
  success: boolean;
  prompt?: string;
  duration_ms?: number;
  error?: string;
}

export const generatePrompt = async (request: PromptGenerationRequest): Promise<string> => {
  try {
    // Get the current user's JWT token using userService
    const token = await userService.getAuthToken();

    const response = await fetch(`${API_BASE_URL}/prompt-generator`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
      body: JSON.stringify(request),
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`HTTP error! status: ${response.status} - ${errorText}`);
    }

    const data: PromptGenerationResponse = await response.json();
    
    if (!data.success) {
      throw new Error(data.error || 'Failed to generate prompt');
    }

    return data.prompt || '';
  } catch (error) {
    console.error('Error generating prompt:', error);
    throw error;
  }
};

